import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { SideNavLoginButtonComponent } from './sidenav-login-button.component';

@NgModule({
  declarations: [SideNavLoginButtonComponent],
  imports: [CommonModule, FlexLayoutModule, MatButtonModule],
  exports: [SideNavLoginButtonComponent]
})
export class LoginButtonModule {}
